import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import portfolioTwoData from './porfolioTwoData';
import PortfolioTwoItem from './PortfolioTwoItem';

const styles = `
.portfolio2-wrap {
    position: relative;
    padding-bottom: 64px;
}

/* ── Arrows – theme-3 parallelogram shape ── */
.portfolio2-btn-prev,
.portfolio2-btn-next {
    position: absolute;
    top: 50%;
    transform: translateY(calc(-50% - 32px));
    z-index: 10;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 32px 32px;
    -webkit-clip-path: polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%);
    clip-path: polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%);
    border-radius: 0;
    border: none;
    background: var(--color-primary, #F5A623);
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.25s, opacity 0.25s;
    white-space: nowrap;
}
.portfolio2-btn-prev { left: 12px; }
.portfolio2-btn-next { right: 12px; }
.portfolio2-btn-prev:hover,
.portfolio2-btn-next:hover {
    background: #202426;
}
.portfolio2-btn-prev.swiper-button-disabled,
.portfolio2-btn-next.swiper-button-disabled {
    opacity: 0.35;
    pointer-events: none;
}

/* ── Always show details on the centered (active) slide ── */
@media (min-width: 992px) {
    .portfolio-carousel-wrapper .swiper-slide-next .single-project-item .project-details {
        transform: translateY(0) !important;
        opacity: 1 !important;
        visibility: visible !important;
    }
}

@media (max-width: 991px) {
    .portfolio-carousel-wrapper .swiper-slide-active .single-project-item .project-details {
        transform: translateY(0) !important;
        opacity: 1 !important;
        visibility: visible !important;
    }
}

/* ── Pagination dots ── */
.portfolio2-pagination {
    position: absolute;
    bottom: 16px;
    left: 0;
    width: 100%;
    display: flex !important;
    justify-content: center;
    gap: 8px;
    z-index: 10;
    line-height: 1;
}
.portfolio2-pagination .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
    display: inline-block;
    transition: background 0.25s, transform 0.25s;
}
.portfolio2-pagination .swiper-pagination-bullet-active {
    background: var(--color-primary, #c9a84c);
    transform: scale(1.35);
}
`;

function Portfolio2() {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const paginationRef = useRef(null);

    return (
        <section className="portfolio-wrapper cases-carousel-wrapper pt-50 section-bg mbm-30" id="products">
            <style>{styles}</style>

            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-12 text-center mb-30">
                        <div className="section-title-3">
                            <p>What We Supply</p>
                            <h1>Our Product Range</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="portfolio2-wrap">
                <div ref={prevRef} className="portfolio2-btn-prev"><BsArrowLeft /></div>
                <div ref={nextRef} className="portfolio2-btn-next"><BsArrowRight /></div>

                <Swiper
                    modules={[Autoplay, Navigation, Pagination]}
                    spaceBetween={30}
                    loop
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    pagination={{
                        el: paginationRef.current,
                        clickable: true,
                    }}
                    onSwiper={(swiper) => {
                        // Bind refs after mount so Swiper sees the real DOM nodes
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                        swiper.navigation.init();
                        swiper.navigation.update();

                        swiper.params.pagination.el = paginationRef.current;
                        swiper.pagination.init();
                        swiper.pagination.render();
                        swiper.pagination.update();
                    }}
                    onTouchEnd={(swiper) => {
                        swiper.autoplay.stop();
                        setTimeout(() => swiper.autoplay.start(), 3000);
                    }}
                    breakpoints={{
                        0:   { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        992: { slidesPerView: 3 },
                    }}
                    className="portfolio-carousel-wrapper"
                >
                    {portfolioTwoData.map((data) => (
                        <SwiperSlide key={data.id}>
                            <PortfolioTwoItem
                                img={data.image}
                                name={data.name}
                                cost={data.cost}
                                heading={data.heading}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div ref={paginationRef} className="portfolio2-pagination" />
            </div>
        </section>
    );
}

export default Portfolio2;
